import React, { useState, useCallback, useEffect } from 'react';
import MenuMain from '../../MenuMain';
import { AppFooter } from '../../AppFooter';
import { FormPrecos } from '../../components/FormPrecos';
import { ErrorRetrievingData } from '../../components/ErrorRetrievingData';
export default function CadastrarPrecoPage() {
  const [isLoading, setIsLoading] = useState(false);
  const [errorRetrievingData, setErrorRetrievingData] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const defaultValues = {
    "id": 0,
    "valor": "",
    "produtoId": 0,
    "produtoNome": "",
    "produtoEmbalagem": "",
    "data": new Date
  }
  
  return (
    <div>
      <MenuMain>
        {
          errorRetrievingData ?
            <ErrorRetrievingData
              errorMessage={errorMessage}
              isLoading={isLoading}
            />
            :
            <FormPrecos
              defaultValues={defaultValues}
              isLoading={isLoading}
              isEditing={false}
            />
        }
      </MenuMain>
      <AppFooter />
    </div>
  );
}

